export const ASSESORS = [
  'maria.espichan@comercio.com.pe',
  'beisi.carrion@comercio.com.pe'
];

export const TERM_AND_CONDITIONS = [
  {
    text: 'Preguntas frecuentes',
    link: 'https://centraldeayuda.clasificados.pe/hc/es/categories/115000332487-Preguntas-Frecuentes'
  },
  {
    text: 'Ayuda en línea',
    link: 'https://centraldeayuda.clasificados.pe/hc/es/requests/new'
  },
  {
    text: 'Términos y Condiciones',
    link: 'https://centraldeayuda.clasificados.pe/hc/es/articles/360040280151-T%C3%A9rminos-y-Condiciones'
  },
  {
    text: 'Políticas de Publicación',
    link: 'https://centraldeayuda.clasificados.pe/hc/es/articles/360040280031-Pol%C3%ADtica-de-Publicaci%C3%B3n'
  },
  {
    text: 'Políticas de Privacidad',
    link: 'https://centraldeayuda.clasificados.pe/hc/es/articles/360039861792-Pol%C3%ADtica-de-Privacidad'
  },
];
